import { GenericFilters } from '@card/types';

export type PaginationParams = Record<string, number>;

const encodeParam = (key: string, value: string) => {
  return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
};

export const getQueryString = (pagination?: PaginationParams, filters?: GenericFilters) => {
  if (!pagination && !filters) return '';
  let paramsArray: string[] = [];
  if (pagination) {
    Object.keys(pagination).map((key) => paramsArray.push(`${key}=${pagination[key]}`));
  }
  if (filters) {
    paramsArray = paramsArray.concat(
      // iterate filter values
      Object.keys(filters).reduce((result: string[], filterKey) => {
        const filterValue = filters[filterKey];
        if (filterValue === '*') {
          // dont filter this
          return result;
        }
        if (Array.isArray(filterValue)) {
          // value is an array
          filterValue.forEach((value: string) => {
            result.push(encodeParam(`${filterKey}[]`, value));
          });
        } else {
          // simple value
          result.push(encodeParam(filterKey, filterValue));
        }
        return result;
      }, [])
    );
  }
  if (paramsArray.length === 0) {
    return '';
  }
  return `?${paramsArray.join('&')}`;
};
